import React from 'react';
import { Table, Card, Typography } from 'antd';
import {stringMixin, money} from "../../utils/strings";



const formatProbabilities = (analysis, prefix) => {
    const stringFormatter = prefix === 'percentile' ? (v) => money(v, 0) : (v) => `${(v * 100).toFixed(2)}%`;

    return Object.entries(analysis)
        .filter(([key]) => key.startsWith(prefix))
        .filter(([key, value]) => !key.includes('-') || (prefix !== 'gmm' && prefix!=='kde'))
        .map(([key, value]) => ({
            key,
            metric: key.replace(`${prefix}_`, '').replace('_', ' '),
            probability: value,
            format: stringFormatter
        }))
        .sort((a, b) => {
            // Distinguishing between 'above' and 'below'
            const directionA = a.metric.includes('below') ? 1 : -1;
            const directionB = b.metric.includes('below') ? 1 : -1;

            if (directionA !== directionB) {
                return directionA - directionB;
            }

            // Extracting and comparing numbers if the directions are the same
            const numA = parseInt(a.metric.match(/\d+/), 10);
            const numB = parseInt(b.metric.match(/\d+/), 10);
            return numA - numB;
        });
};




const columns = [
  {
    title: 'Metric',
    dataIndex: 'metric',
    key: 'metric',
    render: (value) => (
      <Typography.Text>
        {value}{' '}
        {value.includes('below') ? '↓' : '↑'}
      </Typography.Text>
    ),
  },
  {
    title: 'Probability',
    dataIndex: 'probability',
    key: 'probability',
    render: (value, record) => (
      <Typography.Text
        style={{
          color: record.metric.includes('below') ? 'red' : 'black',
        }}
      >
        {record.format(value)}
      </Typography.Text>
    ),
  },
];


const mergeData = (gmmData, kdeData) => {
  return gmmData.map(gmm => {
    const kdeMatch = kdeData.find(kde => kde.metric === gmm.metric);
    return {
      ...gmm,
      kdeProbability: kdeMatch ? kdeMatch.probability : 'N/A'
    };
  });
};

const gmmKdeColumns = [
  {
    title: 'Probabilities',
    dataIndex: 'metric',
    key: 'metric',
    render: value => (
      <Typography.Text>
        {value} {value.includes('below') ? '↓' : '↑'}
      </Typography.Text>
    ),
  },
  {
    title: 'GMM',
    dataIndex: 'probability',
    key: 'gmmProbability',
    render: value => stringMixin.pct(value),
  },
  {
    title: 'KDE',
    dataIndex: 'kdeProbability',
    key: 'kdeProbability',
    render: value => stringMixin.pct(value),
  },
];

const ScenarioProbability = ({ analysis }) => {
  const gmmData = formatProbabilities(analysis, 'gmm');

  const kdeData = formatProbabilities(analysis, 'kde');

  const percentileData = formatProbabilities(analysis, 'percentile');

  const thresholds = formatProbabilities(analysis, 'threshold');

  return (
    <div>
      <Card
          bordered={false}
          title={<Typography.Text>Thresholds</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={thresholds} pagination={false} />
      </Card>
      <Card
          bordered={false}
          title={<Typography.Text>Mixture Probs (Alt 1)</Typography.Text> }
      >
          <Table className={'mid'} columns={gmmKdeColumns} dataSource={mergeData(gmmData, kdeData)} pagination={false} />
      </Card>
      <Card
          bordered={false}
          title={<Typography.Text>Percentiles</Typography.Text> }
      >
          <Table className={'mid'} columns={columns} dataSource={percentileData} pagination={false} />
      </Card>
    </div>
  );
};

export default ScenarioProbability;
